export const queryKeys = {
  getDocument: 'getDocument',
  getDocumentsByProductId: 'getDocumentByProductId',
  getRelatedDocuments: 'getRelatedDocuments',
  getRelatedCertificates: 'getRelatedCertificates'
};
